import { render, staticRenderFns } from "./paymentFail.vue?vue&type=template&id=5e148b96&"
import script from "./paymentFail.vue?vue&type=script&lang=js&"
export * from "./paymentFail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports